import type { CurrencyType } from 'app/schemas/user';
import { Currency } from 'app/schemas/user';

export function getColorByBgColor(bgColor: string | undefined): string {
  if (!bgColor) {
    return '#000';
  }
  return parseInt(bgColor.replace('#', ''), 16) > 0xffffff / 2 ? '#000' : '#fff';
}

export function preparePolicyUrl(url: string, _lang: string, user?: { currency?: CurrencyType | null }) {
  if (url.includes('www.partage.club') || url.includes('www.we-partake.com')) {
    if (user?.currency === Currency.EUR) {
      url = url.replace('/terms-and-conditions', '/terms-and-conditions-europe');
    } else if (user?.currency === Currency.CAD) {
      url = url.replace('/terms-and-conditions', '/terms-and-conditions-ca');
    }
  }
  return url;
}
